import { render } from "./LastCompleted.vue?vue&type=template&id=dd1e8c22&scoped=true"
import script from "./LastCompleted.vue?vue&type=script&lang=js"
export * from "./LastCompleted.vue?vue&type=script&lang=js"

import "./LastCompleted.vue?vue&type=style&index=0&id=dd1e8c22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd1e8c22"]])

export default __exports__